const isProduction = process.env.NODE_ENV === "production";

export const baseFrontendURL = isProduction
  ? "https://www.prioritypop.com"
  : "http://localhost:3000";

export const baseBackendURL = isProduction
  ? "https://www.prioritypop.com"
  : "http://localhost:3001";

console.log("backend", baseBackendURL);
